import axios from "../../axios";

export const project_statusServices = {
    getAll,
};

async function getAll() {
    return await axios.get(`statut_projets`);
}
